import React, { useState } from "react";
import { Button, Popconfirm, Space, message } from "antd";
import { useAuth0 } from "../../../react-auth0-spa";
import { useAppContext } from "../../../context";
import config from "../../../api_config.json";

const FieldTipoLicenza = ({ org }) => {
  const [licenza, setLicenza] = useState(org?.tipo_licenza);
  const [converting, setConverting] = useState(false);
  const { getTokenSilently } = useAuth0();
  const { isProd } = useAppContext();

  const fetchOrgModulesCount = async () => {
    const token = await getTokenSilently();
    const graphqlUrl = `${config.baseUrl[isProd ? "prod" : "dev"]}/graphql?raw=true`;
    const query = `
      query CountOrgModules($orgId: ID!) {
        org_modules(
          first: 1,
          where: { org_pointer: { have: { objectId: { equalTo: $orgId } } } }
        ) {
          count
          edges { node { objectId } }
        }
      }
    `.replace(/\r?\n|\r/g, "").replace(/\t/g, " ");

    const resp = await fetch(graphqlUrl, {
      method: "POST",
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
      body: JSON.stringify({ query, variables: { orgId: org.objectId } }),
    });
    const json = await resp.json();
    if (json.errors) throw new Error(json.errors[0]?.message || "GraphQL error");
    const data = json?.org_modules || {};
    const count = typeof data.count === 'number' ? data.count : (Array.isArray(data.edges) ? data.edges.length : 0);
    return count;
  };

  const convertToModules = async () => {
    try {
      setConverting(true);
      // Safety check: must have at least 1 org_module
      const count = await fetchOrgModulesCount();
      if (!count || count === 0) {
        message.error("Impossibile convertire: crea prima i moduli dell'organizzazione");
        return;
      }

      const token = await getTokenSilently();
      const graphqlUrl = `${config.baseUrl[isProd ? "prod" : "dev"]}/graphql?raw=true`;
      const mutation = `
        mutation UpdateOrganizzazione($id: ID!, $fields: UpdateOrganizzazioneFieldsInput) {
          updateOrganizzazione(input: { id: $id, fields: $fields }) {
            organizzazione { objectId tipo_licenza }
          }
        }
      `.replace(/\r?\n|\r/g, "").replace(/\t/g, " ");

      const body = {
        query: mutation,
        variables: { id: org.objectId, fields: { tipo_licenza: "module" } },
      };

      const resp = await fetch(graphqlUrl, {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
        body: JSON.stringify(body),
      });
      const json = await resp.json();
      if (json.errors) throw new Error(json.errors[0]?.message || "GraphQL error");

      setLicenza("module");
      message.success("Fatto");
    } catch (e) {
      console.error("Errore conversione a Moduli:", e);
      message.error("Si è verificato un problema: " + e.message);
    } finally {
      setConverting(false);
    }
  };

  return (
    <Space size="small">
      <span>{licenza || "-"}</span>
      {licenza !== "module" && (
        <Popconfirm
          title="Sei sicuro di voler aggiornare la org?"
          onConfirm={convertToModules}
          okButtonProps={{ loading: converting }}
        >
          <Button type="link" size="small">Converti a Moduli</Button>
        </Popconfirm>
      )}
    </Space>
  );
};

export default FieldTipoLicenza;
